/**
 * The only public source of truth for Valentine Digital identity and NAP data.
 * Historical records and private customer data must not be rewritten from here.
 */
export const organization = {
  name: "Valentine Digital",
  legalName: "Valentine Digital Marketing Inc.",
  url: "https://valentinedigitalmarketing.com",
  organizationId: "https://valentinedigitalmarketing.com/#organization",
  phoneDisplay: "(989) 843-2600",
  phoneE164: "+1-989-843-2600",
  phoneHref: "tel:+19898432600",
  email: "contact@valentinedigitalmarketing.com",
  emailHref: "mailto:contact@valentinedigitalmarketing.com",
  googleBusinessProfileUrl: "https://share.google/qZVwWO4HABwALWy5k",
  address: {
    streetAddress: "1275 W Morrison Rd",
    addressLocality: "Ubly",
    addressRegion: "MI",
    postalCode: "48475",
    addressCountry: "US",
  },
  socialProfiles: [
    "https://www.facebook.com/valentinedigital",
    "https://www.instagram.com/valentinedigitalmarketing/",
    "https://www.youtube.com/@ValentineDigital",
    "https://www.pinterest.com/valentinedigitalmarketing/",
    "https://share.google/qZVwWO4HABwALWy5k",
  ],
} as const;

export const organizationPostalAddress = {
  "@type": "PostalAddress",
  ...organization.address,
} as const;
